import IndependentChatInput from '@/components/AskMeAnything/components/IndependentChatInput/IndependentChatInput';
import { useCheckList } from '@/hooks/useCheckList';
import TasksView from '@/pages/HomePage/components/tasks/TasksView';
import PageContainer from '@/pages/PageContainer';

import {
  GreetingAndChat,
  TasksCalendarMeetings,
  CalendarAndMeetings,
  TasksContainer,
  HomeContainer,
  CalendarContainer,
  MeetingsContainer
} from './HomeStyles';
import Greeting from './components/Greeting';
import CalendarView from './components/calendarView/CalendarView';
import ChecklistWrapper from './components/checklist/ChecklistWrapper';
import MeetingsView from './components/meetingsView/MeetingsView';

const HomePage = () => {
  const { hideList } = useCheckList();
  return (
    <PageContainer isBackButtonVisible={false}>
      {!hideList && <ChecklistWrapper />}
      <HomeContainer className="home-page">
        <GreetingAndChat>
          <Greeting />
          <IndependentChatInput isChatPage={true} />
        </GreetingAndChat>
        <TasksCalendarMeetings>
          <TasksContainer>
            <TasksView />
          </TasksContainer>
          <CalendarAndMeetings>
            <CalendarContainer>
              <CalendarView />
            </CalendarContainer>
            <MeetingsContainer>
              <MeetingsView />
            </MeetingsContainer>
          </CalendarAndMeetings>
        </TasksCalendarMeetings>
      </HomeContainer>
    </PageContainer>
  );
};

export default HomePage;
